import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../../utilities/TabUtilities";
var tinycolor = require("tinycolor2");

export default class PolaczenieEkipIPojazdowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderEkipa = this.renderEkipa.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj połaczenie'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń połaczenie'}/>
            </div>
        )
    }

    renderEkipa(cell, row) {
        if (this.props.ekipy.length > 0) {
            let ekipa = this.props.ekipy.find(e => e.idEk === row.idEk)
            if (ekipa) {

                let color = 'grey';

                if((tinycolor(ekipa.kolor)).isDark()){
                    color = '#ffffff'
                }
                if((tinycolor(ekipa.kolor)).isLight()){
                    color = '#000000'
                }

                return (
                    <div>
                        <span className={'label label-ebus-default'}
                              style={(ekipa.kolor.length > 1) ? {background: ekipa.kolor, color:color} : {background: '#f5f5f5', color: '#333333'}}>
                            {ekipa.kodEk}
                        </span>
                    </div>
                )
            }
        }
    }

    renderZmiana(cell,row){
        if(Boolean(cell)){
            return cell
        }
        else return ''
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 15 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów'
        };

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idEkp' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='kodEk'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}

                                       dataFormat={this.renderEkipa}
                    >Kod ekipy</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazwaEk'
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Nazwa ekipy</TableHeaderColumn>

                    <TableHeaderColumn dataField='informacje'
                                       thStyle={tabgrid.tg9} tdStyle={tabgrid.tg9}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Pojazd</TableHeaderColumn>
                    <TableHeaderColumn dataField='zmiana'
                                       thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderZmiana}
                    >Zmiana</TableHeaderColumn>
                    <TableHeaderColumn dataField='idEkp'
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/polaczenieEkipIPojazdow/components/PolaczenieEkipIPojazdowTable.js